import Dashboard from './components/Dashboard'
import ErrorBoundary from './components/ErrorBoundary'
import './App.css'

function App() {
  return (
    <ErrorBoundary>
      <div className="min-h-screen bg-gray-50">
        <Dashboard />
      </div>
    </ErrorBoundary>
  )
}

export default App
